import { date, number, object, string } from 'yup';
import i18n from 'i18next';

const handleEditCaseForUnkownState = ({ iftaDetails }) => {
  function getSchemaObj() {
    return {
      state: object()
        .required(i18n.t('common.fieldRequiredMessage'))
        .test('is-not-unknown', i18n.t('common.customStateErrorMessage'), (value) => value?.value !== 'Unknown'),
      addressFrom: string().required(i18n.t('common.fieldRequiredMessage')),
      addressTo: string().required(i18n.t('common.fieldRequiredMessage')),
      startCity: string().required(i18n.t('common.fieldRequiredMessage')),
      endCity: string().required(i18n.t('common.fieldRequiredMessage')),
    };
  }

  if (!iftaDetails?.iftaMileageId || (iftaDetails?.iftaMileageId && iftaDetails?.isUnknownState)) {
    return getSchemaObj();
  }

  return {};
};

export const getSchema = ({ iftaDetails }) => ({
  totalMiles: number(),

  ...(!iftaDetails?.iftaMileageId && {
    vehicle: string().required(i18n.t('common.fieldRequiredMessage')),
    driver: string().required(i18n.t('common.fieldRequiredMessage')),
    date: date().required(i18n.t('common.fieldRequiredMessage')),
  }),

  ...handleEditCaseForUnkownState({ iftaDetails }),

  taxable: string().required(),
  startMeter: number()
    .typeError('you must specify a number')
    .required(i18n.t('common.fieldRequiredMessage'))
    .moreThan(-1, i18n.t('iftaMileage.notLessThanZero')),
  endMeter: number()
    .typeError('you must specify a number')
    .required(i18n.t('common.fieldRequiredMessage'))
    .moreThan(0, i18n.t('iftaMileage.notLessThanZero'))
    .when('startMeter', (startMeter, schema) => {
      return schema.test({
        test: (endMeter) => {
          if (!endMeter) return true;
          return startMeter < endMeter;
        },
        message: 'end meter should be greater than start meter',
      });
    }),
});
